import { Component, Inject, OnInit } from "@angular/core";
import { FlowTemplate, Transition, SideEffect, SaveDataConfig, SaveDataSettings } from "../../../../common/models/flow.dto";
import { EntityMap, RelatedEntityMap } from "../../../models/entity.model";
import { SideEffectData, SIDE_EFFECT_DATA_TOKEN } from "./models/types";

@Component({
    selector: "side-effect-savedatabase",
    templateUrl: "side-effect-savedatabase.component.html",
    styleUrls: ["./side-effect-savedatabase.component.scss"],
    standalone: false
})
export class SideEffectSaveDatabaseComponent implements OnInit {
    transition: Transition;
    sideEffect: SideEffect;
    template: FlowTemplate;
    

    get showEntityMaps(): boolean {
        if (this.template && this.template.entityMaps)
            return this.template.entityMaps.length > 0;

        return false;
    }

    get entityMaps(): Array<EntityMap> {
        if (this.template === undefined ||
            this.template === null ||
            this.template.entityMaps === undefined ||
            this.template.entityMaps === null) {
            this.template.entityMaps = new Array<EntityMap>();
        }

        return this.template.entityMaps;
    }

    constructor(@Inject(SIDE_EFFECT_DATA_TOKEN) public data: SideEffectData) {
        this.sideEffect = data.sideEffect;
        this.template = data.template;
        this.transition = data.transition;
    }

    ngOnInit() {
        if (this.sideEffect.configuration === undefined || this.sideEffect.configuration === null) {
            this.sideEffect.configuration = { entityMapIds: [], entities: [] } as SaveDataConfig;
        } else if (!this.sideEffect.configuration.entities) {
            this.sideEffect.configuration.entities = [];
        }
        if (this.sideEffect.configuration.entities.length !== this.entityMaps.length) {
            for (let c = 0; c < this.entityMaps.length; c++) {
                let doAdd = false;
                let map = this.sideEffect.configuration.entities.find(f => f.mapId === this.entityMaps[c].id);
                if (!map) {
                    doAdd = true;
                    const isSaved = this.sideEffect.configuration.entityMapIds.find(i => i === this.entityMaps[c].id) !== undefined;
                    map = { mapId : this.entityMaps[c].id, isPreview: false, parentMapId: "", previewContext: "", relatedEntities: [], saveEntity: isSaved } as SaveDataSettings;
                }
                const relatedMaps = this.entityMaps[c].relatedEntityMaps;
                if (relatedMaps) {
                    for (let r = 0; r < relatedMaps.length; r++) {
                        let related = map.relatedEntities.find(e => e.mapId === relatedMaps[r].id);
                        if (!related) {
                            const isSaved = this.sideEffect.configuration.entityMapIds.find(i => i === relatedMaps[r].id) !== undefined;
                            related = { mapId: relatedMaps[r].id, isPreview: false, parentMapId: this.entityMaps[c].id, previewContext: "", relatedEntities: [], saveEntity: isSaved };
                            map.relatedEntities.push(related);
                        }
                    }
                }
                if (doAdd) {
                    this.sideEffect.configuration.entities.push(map);
                }
            }
            this.sideEffect.configuration.entityMapIds = [];
        }
    }

    getMapEntity(id: string): string {
        const map = this.entityMaps.find(m => m.id === id);
        let entityName = "";
        if (map) {
            entityName = map.entity.entityName;
        } else {
            for (let m = 0; m < this.entityMaps.length; m++) {
                const parent = this.entityMaps[m];
                if (!parent.relatedEntityMaps || parent.relatedEntityMaps.length === 0) continue;
                const related = parent.relatedEntityMaps.find(r => r.id === id);
                if (related) {
                    entityName = related.entity.entityName;
                }
                if (entityName.length > 0) break;
            }
        }
        
        return entityName;
    }

    getMapName(id: string): string {
        const map = this.entityMaps.find(m => m.id === id);
        let name = "";
        if (map) {
            name = map.mapName;
        } else {
            for (let m = 0; m < this.entityMaps.length; m++) {
                const parent = this.entityMaps[m];
                if (!parent.relatedEntityMaps || parent.relatedEntityMaps.length === 0) continue;
                const related = parent.relatedEntityMaps.find(r => r.id === id);
                if (related) {
                    name = related.mapName;
                }
                if (name.length > 0) break;
            }
        }
        return name;
    }

    getPreviewId(id: string): string {
        return `${id}_Preview`;
    }

    getRelated(id: string): RelatedEntityMap[] {
        const map = this.entityMaps.find(m => m.id === id);
        if (map) {
            return map.relatedEntityMaps;
        }
        return [];
    }

    getRelationalProperty(parentId: string, relatedMapId: string): string {
        let propertyName = "";
        const parent = this.entityMaps.find(e => e.id === parentId);
        if (parent) {
            const child = parent.relatedEntityMaps.find(r => r.id === relatedMapId);
            if (child) {
                propertyName = child.relationalProperty;
            }
        }
        return propertyName;
    }

    mapSaveChanged(mapId: string): void {
        const map = this.sideEffect.configuration.entities.find(e => e.mapId === mapId) as SaveDataSettings;
        if (map) {
            if (!map.saveEntity) {
                map.isPreview = false;
                if (map.relatedEntities) {
                    for (let r = 0; r < map.relatedEntities.length; r++) {
                        map.relatedEntities[r].saveEntity = false;
                        map.relatedEntities[r].isPreview = false;
                    }
                }
            }           
        }
    }

    previewOnlyChanged(mapId: string): void {
        let map = this.sideEffect.configuration.entities.find(m => m.mapId === mapId) as SaveDataSettings;
        for (let r = 0; r < map.relatedEntities.length; r++) {
            map.relatedEntities[r].isPreview = map.isPreview;
        }
        
    }   

    
}